<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-1" [routerLink]="['/on-demand/event-log']">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-9">
      <h2 class="col pb-2 m-0 title">
        {{ "EVENT_LOG_DATA" | translate }}
        {{ "DETAILS" | translate }}
      </h2>
      <h6 class="col subtitle">
        {{ "ONDEMANDEVENTLOG_SUBTITLE" | translate }}
      </h6>
    </div>
    @if (
      authService.isAuthorized([PermissionEnum.Ondemand_event_log_download])
    ) {
      <div
        class="col-md-2 d-flex justify-content-end align-items-center gap-2 pe-5"
      >
        <div class="download-button ps-3 pe-3 pb-2 pt-1" (click)="download()">
          <svg-icon
            alt="Download"
            class="hover-effect"
            src="assets/core/table/download.svg"
          ></svg-icon>
        </div>
      </div>
    }
  </div>
  <div class="row g-0 m-0 pt-4">
    <ul>
      @for (eventLogNumber of eventLogNumbers; track eventLogNumber) {
        <li
          [class.active]="requestData.eventLogNumber === eventLogNumber"
          (click)="selectEventLog(eventLogNumber)"
        >
          <span class="event-log-name">{{ "EVENTLOG_TYPE_" + eventLogNumber | translate }}</span>
          <span class="event-log-number">{{ "EVENTLOG_" + eventLogNumber | translate }}</span>
        </li>
      }
    </ul>
  </div>
  <div #tableContainer class="table-container mt-5">
    <table>
      <thead>
        <tr>
          <td>{{ "TIME" | translate }}</td>
          <td>{{ "EVENT_CODE" | translate }}</td>
          <td>{{ "EVENT" | translate }}</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td class="event-time">
            <span>{{ item.time | date: "dd MMM yyyy, h:mm a" }}</span>
          </td>
          <td>
            <span>{{ item.eventCode }}</span>
          </td>
          <td>
            <span>{{ item.eventName ?? "N/A" }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="container-down">
    <app-pagination
      [lastPageSize]="lastPageSize"
      [numberOfDevices]="numberOfCommands"
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      (pageChange)="pageChange($event)"
    ></app-pagination>
  </div>
</div>
